import React, { Dispatch, SetStateAction } from 'react';
import './hamburgerMenu.scss';

type HamburgerMenuProps = {
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
  };

const HamburgerMenu:React.FC<HamburgerMenuProps> = ({ open, setOpen }) => {
	const handleClick = () => {
	  setOpen(!open);
	};

	return (
		<div 
			className={`hamburger ${open ? 'hamburger--active' : ''}`} 
			onClick={handleClick} 
			data-testid="hamburger-menu"
		>
			<span className="hamburger__line"></span>
			<span className="hamburger__line"></span>
			<span className="hamburger__line"></span>
		</div>
	)
}

export default HamburgerMenu